import React, { useEffect } from 'react';
import { useCredits } from '../../contexts/CreditContext';
import { JobDescriptionUpload } from '../JobDescriptionUpload';
import { ResumeUpload } from '../ResumeUpload';
import { ResumeTable } from '../ResumeTable';

// Dashboard content component that uses credits context
const DashboardContent: React.FC = () => {
  const { fetchCredits } = useCredits();

  useEffect(() => {
    // Fetch credits when dashboard loads
    fetchCredits();
  }, [fetchCredits]);

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Welcome Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-base-content">Dashboard</h1>
        <p className="text-base-content/70 mt-2">Upload job descriptions and resumes, then analyze them with AI.</p>
      </div>
      
      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <div className="bg-base-100 rounded-lg shadow-lg p-6 border border-base-300">
          <JobDescriptionUpload />
        </div>
        
        <div className="bg-base-100 rounded-lg shadow-lg p-6 border border-base-300">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-base-content mb-2">Upload Resumes</h2>
            <p className="text-base-content/70">Choose the role and upload resumes for analysis</p>
          </div>
          <ResumeUpload />
        </div>
      </div>
      
      <div className="bg-base-100 rounded-lg shadow-lg p-6 border border-base-300">
        <ResumeTable />
      </div>
    </div>
  );
};

// Main Dashboard component
export const Dashboard: React.FC = () => {
  return <DashboardContent />;
}; 